app.directive('productListVariationSelector', [
  'imageService',
  'mainConfig',
  function (imageService, mainConfig) {
    return {
      restrict: 'E',
      scope: {
        variantProductImages: '=',
        productId: '@',
        productUrl: '@',
        openLinkInNewTab: '=',
        showVariationType: '@',
        isPromotionProduct: '=',
        queryProductImageWidth: '=',
      },
      templateUrl:
        '/themes/shared/product/templates.product_list_variation_selector.html',
      link: function (scope, element) {
        function checkMediaSize() {
          scope.isMobile = window.matchMedia('(max-width: 480px)').matches;
          scope.isTablet = window.matchMedia(
            '(min-width: 481px) and (max-width: 991px)',
          ).matches;
        }
        checkMediaSize();

        scope.variantCount =
          scope.variantProductImages[
            'variation_set_' + scope.showVariationType + '_total'
          ];
        scope.showVariantProductImages =
          scope.variantProductImages[
            'variation_set_' + scope.showVariationType
          ];

        function getUrlParam(variantOption) {
          if (variantOption) {
            return location.search
              ? location.search + '&variant_id=' + variantOption.key
              : '?variant_id=' + variantOption.key;
          } else {
            return location.search;
          }
        }

        var skipClickTarget =
          '.product-list-variant-selector-toggle > span, .product-list-variant-selector-list';
        element.on('click', function (e) {
          if ($(e.target).is(skipClickTarget)) {
            e.preventDefault();
          }
        });

        scope.state = {
          expand: false,
          maxVariantsCount: 6,
          showLeftMask: false,
          showRightMask: false,
          hoveredOption: {},
        };

        scope.toggleVariantsExpand = function () {
          scope.state.expand = !scope.state.expand;
          if (scope.state.expand) {
            scope.state.maxVariantsCount *= 2;
          } else {
            scope.state.maxVariantsCount /= 2;
          }
        };

        var productElement = $('[product-id=' + scope.productId + ']');
        var productQuerySelectors = [
          '[product-id=' + scope.productId + '] > a',
          'a[product-id=' + scope.productId + ']',
        ];

        var currentThemeKey = mainConfig.merchantData.current_theme_key;
        var productHrefElement = $(productQuerySelectors.join(', '));
        if (currentThemeKey === 'swanky') {
          productElement = productElement.filter(function (idx) {
            return (
              $(productElement[idx]).next().is(element) ||
              $(productElement[idx]).has(element).length
            );
          });
          var anchorProductElement = productElement.filter(function (idx) {
            return $(productElement[idx]).is('a');
          });
          productHrefElement = anchorProductElement.length
            ? anchorProductElement
            : productElement.find('> a');
        } else {
          productElement = productElement.has(element);
          productHrefElement = productHrefElement.has(element);
        }

        var imagesQuerySelectors = [
          '.js-image-boxify-image', // quick cart image selector
          '.js-image-boxify-image .js-boxify-image', // product image selector
          '.boxify-image', // promotion product image selector
        ];

        var imagesQuery = productElement.find(imagesQuerySelectors.join(','));

        function updateVariantsLengthByMedia() {
          if (scope.isMobile) {
            scope.state.maxVariantsLength = 116;
            scope.state.maxVariantsCount = scope.state.expand ? 8 : 4;
          } else {
            scope.state.maxVariantsLength = scope.isTablet ? 174 : 204;
            scope.state.maxVariantsCount = scope.state.expand ? 12 : 6;
          }
        }

        function updateVariantsLengthByImage() {
          var productImageWidth = imagesQuery[0].clientWidth;
          if (currentThemeKey === 'hype') {
            productImageWidth -= 20;
          }
          var variationImageWidth = scope.isMobile || scope.isTablet ? 29 : 24;
          var rowVariantsCount = Math.min(
            parseInt(productImageWidth / variationImageWidth),
            6,
          );
          scope.state.maxVariantsCount = scope.state.expand
            ? 2 * rowVariantsCount
            : rowVariantsCount;
          scope.state.maxVariantsLength =
            variationImageWidth * rowVariantsCount;
        }

        function updateVariantsLength() {
          if (scope.queryProductImageWidth) {
            updateVariantsLengthByImage();
          } else {
            updateVariantsLengthByMedia();
          }
        }
        updateVariantsLength();

        scope.getShowMoreAmount = function () {
          return (
            scope.variantCount -
            (scope.isMobile || scope.isTablet
              ? scope.showVariantProductImages.length
              : scope.state.maxVariantsCount)
          );
        };

        scope.getMaxWidth = function () {
          return 'min(100%, ' + scope.state.maxVariantsLength + 'px)';
        };

        function checkShouldShowRightMask() {
          scope.state.showRightMask =
            (scope.isMobile || scope.isTablet) &&
            scope.showVariantProductImages.length >
              scope.state.maxVariantsCount;
        }
        checkShouldShowRightMask();

        $(window).on(
          'resize',
          _.debounce(function () {
            checkMediaSize();
            checkShouldShowRightMask();
            updateVariantsLength();
          }, 100),
        );

        var originalImageUrl = imagesQuery
          .first()
          .css('background-image')
          .replace('url(', '')
          .replace(')', '')
          .replace(/\"/gi, '');
        var imageSize = imagesQuery.first().attr('data-size') || '400x';

        var quickCartBtnElement = productElement.find(
          scope.isPromotionProduct
            ? '.btn-add-to-promotion-cart'
            : '.btn-add-to-cart',
        );
        var imageElement = productElement.find(imagesQuery);
        var showMoreElement = element.find(
          '.product-list-variant-selector-show-more',
        );
        showMoreElement.attr('href', scope.productUrl);

        scope.updatePreviewProduct = function (e, variantOption) {
          var imageUrl =
            variantOption && variantOption.variation_media
              ? imageService.getMediaImageUrl(variantOption.variation_media, {
                  size: imageSize,
                })
              : originalImageUrl;
          imageElement.css('background-image', 'url(' + imageUrl + ')');
          var newProductUrl =
            scope.productUrl.split('?')[0] + getUrlParam(variantOption);
          productHrefElement.attr('href', newProductUrl);
          showMoreElement.attr('href', newProductUrl);
          quickCartBtnElement.attr('data-variant-id', variantOption.key);
          scope.state.hoveredOption = variantOption ? variantOption : {};
          var wishlistElement = productElement.find(
            'sl-list-page-wishlist-button',
          );
          wishlistElement.attr('data-variant-id', variantOption.key);

          e.preventDefault();
        };

        scope.getVariantImageUrl = function (url) {
          return imageService.getMediaImageUrl(url, { size: '30x30' });
        };

        var scrollableQuery = element.find(
          '.product-list-variant-selector-scrollable',
        );
        scrollableQuery.scroll(
          _.debounce(function ($event) {
            if (scope.isMobile || scope.isTablet) {
              scope.state.showLeftMask = $event.target.scrollLeft > 0;
              scope.state.showRightMask =
                $event.target.scrollLeft + $event.target.offsetWidth <
                $event.target.scrollWidth;
              scope.$apply();
            }
          }, 25),
        );

        $(
          '[product-id=' +
            scope.productId +
            '] .product-list-variant-selector-right-mask',
        ).click(function ($event) {
          if (scope.isMobile || scope.isTablet) {
            scrollableQuery[0].scrollBy({
              top: 0,
              left: scope.state.maxVariantsLength / 2,
              behavior: 'smooth',
            });
            $event.preventDefault();
          }
        });
        $(
          '[product-id=' +
            scope.productId +
            '] .product-list-variant-selector-left-mask',
        ).click(function ($event) {
          if (scope.isMobile || scope.isTablet) {
            scrollableQuery[0].scrollBy({
              top: 0,
              left: -scope.state.maxVariantsLength / 2,
              behavior: 'smooth',
            });
            $event.preventDefault();
          }
        });
      },
    };
  },
]);
